import {React,useContext} from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';
import ThemeContext from '../../context/ThemeContext';

const Sidebar = ({ toggleSidebar }) => {
  const {theme} = useContext(ThemeContext)
  return (
    <div className={`sidebar ${theme} active`}>
      <button className={`close-btn ${theme}`} onClick={toggleSidebar}>&times;</button>
      <ul>
        <li><Link to="/" onClick={toggleSidebar}>Work</Link></li>
        <li><Link to="/about" onClick={toggleSidebar}>About</Link></li>
      </ul>
    </div>
  );
};

export default Sidebar;
